import { createSSRApp, createApp as createClientApp } from "vue";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";

import router from "./router";
import i18n from "./services/i18n";

import Flicking from "@egjs/vue3-flicking/dist/flicking.esm";
import "@egjs/vue3-flicking/dist/flicking.css";
import "animate.css";

import App from "./App.vue";

export function createApp() {
  // 🔑 WICHTIG: App-Typ abhängig von Umgebung
  const app = import.meta.env.SSR
    ? createSSRApp(App)
    : createClientApp(App);

  // Plugins
  const pinia = createPinia();
  const head = createHead();

  app.use(pinia);
  app.use(router);
  app.use(i18n);
  app.use(head);

  // Globale Komponenten
  app.component("Flicking", Flicking);

  return { app, router, pinia };
}
